<div class="wrapper">
  <app-header heading="{{ 'CLIENT_PROFILE.HEADER.TITLE' | translate }}"></app-header>
  <div class="flex menu">
    <button
      mat-flat-button
      disableRipple
      [class.selected]="tab === 'bank-account-edit'"
      (click)="selectTab('bank-account-edit')"
    >
      {{ "CLIENT_PROFILE.MENU.BANK_ACCOUNT" | translate }}
    </button>
    <button
      mat-flat-button
      disableRipple
      [class.selected]="tab === 'notification-settings'"
      (click)="selectTab('notification-settings')"
    >
      {{ "CLIENT_PROFILE.MENU.NOTIFICATIONS" | translate }}
    </button>
    <button
      mat-flat-button
      disableRipple
      [class.selected]="tab === 'user-options'"
      (click)="selectTab('user-options')"
    >
      {{ "CLIENT_PROFILE.MENU.TOV" | translate }}
    </button>
    <button
      mat-flat-button
      disableRipple
      [class.selected]="tab === 'api-integrations'"
      (click)="selectTab('api-integrations')"
    >
      {{ "CLIENT_PROFILE.MENU.INTEGRATIONS" | translate }}
    </button>
    <div
      class="client-id-box flex vcenter"
      matTooltipPosition="above"
      matTooltipClass="client-id-tooltip"
      role="button"
      tabindex="0"
      (click)="copyIdToClipboard($event)"
      (keydown.enter)="copyIdToClipboard($event)"
      (keydown.space)="copyIdToClipboard($event); $event.preventDefault()"
    >
      <span class="client-id-text">{{ client?.client_reference_id }}</span>
      <payee-icon
        name="copy-blue"
        width="14px"
        height="14px"
        class="client-id-icon"
      ></payee-icon>
    </div>
  </div>
  <div class="flex content column">
    @if (tab === "bank-account-edit") {
      <app-bank-account-edit></app-bank-account-edit>
    }
    @if (tab === "user-options") {
      <app-client-options></app-client-options>
    }
    @if (tab === "api-integrations") {
      <app-api-integrations></app-api-integrations>
    }
    @if (tab === "notification-settings") {
      <app-notification-settings></app-notification-settings>
    }
  </div>
</div>
